import Joi from 'joi';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export const phoneNumberExtension = (joi: Joi.Root): Joi.Extension => ({
  type: 'phoneNumber',
  base: joi.string(),
  messages: {
    'phoneNumber.invalid': '{{#label}} is not a valid phone number.'
  },
  prepare: (value: string | number | null | undefined) => {
    const cleanNumber = value ? value.toString().replace(/[^+\d]/g, '') : null;
    if (cleanNumber === '' || cleanNumber == null) return { value: null };
    try {
      const phoneNumber = parsePhoneNumberFromString(cleanNumber);
      return {
        value: phoneNumber?.formatInternational() || cleanNumber
      };
    } catch (e) {
      console.warn('phoneNumberExtension()->e:', e);
      return {
        value: cleanNumber
      };
    }
  }
});
